/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PreviewEquipmentDetailsViewRequest = {
  /**
   * The id of the device to get the equipment details view for
   */
  deviceId: string;
  agentId: string;
  body: components.PreviewEquipmentBulkEditViewRequestBody;
};

/** @internal */
export const PreviewEquipmentDetailsViewRequest$inboundSchema: z.ZodType<
  PreviewEquipmentDetailsViewRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  device_id: types.string(),
  agent_id: types.string(),
  body: components.PreviewEquipmentBulkEditViewRequestBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "device_id": "deviceId",
    "agent_id": "agentId",
  });
});
/** @internal */
export type PreviewEquipmentDetailsViewRequest$Outbound = {
  device_id: string;
  agent_id: string;
  body: components.PreviewEquipmentBulkEditViewRequestBody$Outbound;
};

/** @internal */
export const PreviewEquipmentDetailsViewRequest$outboundSchema: z.ZodType<
  PreviewEquipmentDetailsViewRequest$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentDetailsViewRequest
> = z.object({
  deviceId: z.string(),
  agentId: z.string(),
  body: components.PreviewEquipmentBulkEditViewRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    deviceId: "device_id",
    agentId: "agent_id",
  });
});

export function previewEquipmentDetailsViewRequestToJSON(
  previewEquipmentDetailsViewRequest: PreviewEquipmentDetailsViewRequest,
): string {
  return JSON.stringify(
    PreviewEquipmentDetailsViewRequest$outboundSchema.parse(
      previewEquipmentDetailsViewRequest,
    ),
  );
}
export function previewEquipmentDetailsViewRequestFromJSON(
  jsonString: string,
): SafeParseResult<PreviewEquipmentDetailsViewRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      PreviewEquipmentDetailsViewRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreviewEquipmentDetailsViewRequest' from JSON`,
  );
}
